import React from 'react';
import PropTypes from 'prop-types';

import { Col, Row } from '@zillow/zrs-comet';
import { Paragraph, Text } from '@zillow/constellation';

import SvgTreeline from 'app/shared/images/treeline-illustration.svg';
import {
    StyledImageForSvg,
    StyledCard,
    StyledIconChevronRightCircle,
} from './StyledComponents';

const ApplicationSummaryCard = ({
    onApplicationSummaryClick,
    remainingCount,
    remainingCountNew,
    urlPath,
}) => {
    const handleCardClick = () => {
        onApplicationSummaryClick();
        window.router.updateLocation(urlPath);
    };

    return (
        <StyledCard cardType="secondary" onClick={handleCardClick}>
            <Row>
                <Col>
                    <Paragraph fontType="bodySmallHeading">
                        {`+ ${remainingCount} applications...`}
                    </Paragraph>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Paragraph marginTop="xs" marginBottom="sm" fontType="bodySmall">
                        Includes
                        <Text fontColor="orange400" fontType="bodySmallHeading">
                            {` ${remainingCountNew} new `}
                        </Text>
                        applications.
                    </Paragraph>
                </Col>
            </Row>
            <Row marginTop="sm">
                <Col xs={6} md={4} lg={10}>
                    <StyledImageForSvg src={SvgTreeline} alt="background" />
                </Col>
                <Col noPadding={true} xs={6} md={8} lg={2}>
                    <StyledIconChevronRightCircle size="sm" />
                </Col>
            </Row>
        </StyledCard>
    );
};

ApplicationSummaryCard.propTypes = {
    remainingCount: PropTypes.number.isRequired,
    remainingCountNew: PropTypes.number.isRequired,
    urlPath: PropTypes.string.isRequired,
    onApplicationSummaryClick: PropTypes.func,
};

ApplicationSummaryCard.defaultProps = {
    onApplicationSummaryClick: () => {},
};

export default ApplicationSummaryCard;
